import { ComboboxData } from '@mantine/core';
import { Session } from 'interfaces/session.interface';
import { formatName, tableDateFormatter } from '@/utilities/shared/formatters';

export const tableSessionAdapter = (data: Session[]) => {
  return (
    data?.map(
      ({
        _id,
        coachee: coacheeParam,
        coach: coachParam,
        date,
        status,
        sessionNumber,
        company,
        noShow,
        canceled,
      }) => {
        const coach = formatName(coachParam?.name, coachParam?.lastname);
        const coachee = formatName(coacheeParam?.name, coacheeParam?.lastname);
        const dateFormatted =
          tableDateFormatter(
            date,
            coacheeParam?.timezone?.length === 0 && !coacheeParam?.timezone
              ? coachParam?.timezone
              : coacheeParam?.timezone,
          ) ?? '-';
        const statusLabel = getStatusLabel(status, canceled);

        return {
          id: _id,
          date: dateFormatted,
          coach,
          coachee,
          coacheeEmail: coacheeParam?.email ?? '-',
          coachEmail: coachParam?.email ?? '-',
          noShow: noShow ? 'Si' : 'No',
          status: statusLabel,
          canceled: canceled ? 'Si' : 'No',
          sessionNumber: sessionNumber ?? '-',
          company: company?.name ?? '-',
          completed: status ? 'Si' : 'No',
        };
      },
    ) ?? []
  );
};

export type UserComboBoxData = {
  _id: string;
  name: string;
  lastname: string;
};
export const userComboBoxAdapter = (data: UserComboBoxData[]): ComboboxData => {
  return (
    data
      ?.filter((user) => user._id)
      .map((user) => ({
        value: user._id,
        label: formatName(user.name, user.lastname),
      })) ?? []
  );
};

export type CompanyComboBoxData = {
  _id: string;
  name: string;
};

export const companyComboBoxAdapter = (data: CompanyComboBoxData[]): ComboboxData => {
  return (
    data
      ?.filter((company) => company._id)
      .map((company) => ({
        value: company._id,
        label: company.name,
      })) ?? []
  );
};

type returnNoShowAdapterProps = {
  id: string;
  date: string /* Formatted date string by tableDateFormatter*/;
  coach: string;
  coachee: string;
  noShow: boolean;
  status: string;
};

export const tableNoShowAdapter = (data: Session[]): returnNoShowAdapterProps[] => {
  return (
    data?.map(
      ({ _id, coachee: coacheeParam, coach: coachParam, date, status, noShow, canceled }) => {
        const coach = formatName(coachParam?.name, coachParam?.lastname);
        const coachee = formatName(coacheeParam?.name, coacheeParam?.lastname);
        const dateFormatted =
          tableDateFormatter(
            date,
            coacheeParam?.timezone?.length === 0 && !coacheeParam?.timezone
              ? coachParam?.timezone
              : coacheeParam?.timezone,
          ) ?? '-';
        const statusLabel = getStatusLabel(status, canceled);
        return {
          selected: false,
          id: _id,
          date: dateFormatted,
          coach,
          coachee,
          noShow,
          status: statusLabel,
          canceled: canceled ? 'Si' : 'No',
          completed: status ? 'Si' : 'No',
          coacheeEmail: coacheeParam?.email ?? '-',
          coachEmail: coachParam?.email ?? '-',
        };
      },
    ) ?? []
  );
};

const getStatusLabel = (status: boolean, canceled: boolean): string => {
  const { label } = statusOptions.find((opt) => opt.when(status, canceled))!;
  return label;
};

export const statusOptions = [
  {
    when: (s: boolean, c: boolean) => s && c,
    label: 'Finalizada y Cancelada',
    color: 'yellow',
  },
  {
    when: (s: boolean) => s,
    label: 'Finalizada',
    color: 'green',
  },
  {
    when: (_: boolean, c: boolean) => c,
    label: 'Cancelada',
    color: 'red',
  },
  {
    when: () => true,
    label: 'Agendada',
    color: 'blue',
  }, // Default fallback
];
